import React, { useState } from 'react';
import { AutoComplete, Button, Space } from 'antd';
import { _T } from '../src/Localization';
export const SearchUser = ({ onFilter, onFinish, disabled, placeholder }) => {
    const [value, setValue] = useState('');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const onSelect = (data) => {
        setLoading(true);
        setOptions([]);
        onFinish(data, done);
    };
    const onChange = async (data) => {
        setValue(data);
        const result = await onFilter(data);
        setOptions(result);
    };
    const done = () => {
        setLoading(false);
        setValue('');
    };
    return (React.createElement(Space.Compact, { style: { width: '100%' } },
        React.createElement(AutoComplete, { value: value, options: options, style: { width: '100%' }, onSelect: onSelect, onChange: onChange, placeholder: placeholder || _T('common.search', { name: _T('users.title').toLowerCase() }), disabled: disabled || loading, allowClear: true }),
        React.createElement(Button, { type: "primary", loading: loading, disabled: disabled || loading || !value, onClick: () => onSelect(value) }, _T('common.add'))));
};
